import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundColor: 'rgb(255,255,255)',
    borderTop: '1px solid rgba(168,85,247,0.20)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-151">
      <div className="mx-auto max-w-4xl text-center" data-id="element-152">

        {/* ── LOGO ── */}
        <div className="mb-3 text-xl font-black tracking-[2.4px]" style={{
        background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }} data-id="element-153">
          👶 CONSTRUYE PROGRESO™
        </div>

        {/* ── TAGLINE ── */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-600 m-0 mb-3" data-id="element-154">
          El sistema N°1 para madres que quieren estimular el desarrollo de su
          hijo con criterio, confianza y sin improvisar.
        </p>

        <p className="text-xs italic text-gray-500 m-0 mb-6 px-4" data-id="element-155">
          "Porque los primeros 3 años no se repiten — y tu hijo merece que los
          aproveches al máximo."
        </p>

        {/* ── CONTACT ── */}
        <div className="mb-6 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs text-gray-600" data-id="element-156">
          <a href="mailto:construyeprogresoo@gmail.com" className="no-underline text-gray-600 transition-colors hover:text-purple-700" data-id="element-157">
            📧 construyeprogresoo@gmail.com
          </a>
          <span className="hidden sm:block text-gray-200" data-id="element-158">|</span>
          <span className="text-gray-600" data-id="element-159">📲 @construyeprogresoo</span>
          <span className="hidden sm:block text-gray-200" data-id="element-160">|</span>
          <a href="https://www.construyeprogreso.com" target="_blank" rel="noopener noreferrer" className="no-underline text-gray-600 transition-colors hover:text-purple-700" data-id="element-161">
            🌐 www.construyeprogreso.com
          </a>
        </div>

        {/* ── DIVIDER ── */}
        <div className="mx-auto mb-6 h-px w-24" style={{
        background: 'linear-gradient(to right, #7c3aed, #ec4899)',
        opacity: 0.3
      }} data-id="element-162" />

        {/* ── LEGAL ── */}
        <div className="space-y-1" data-id="element-163">
          <p className="text-[10px] text-gray-500 m-0" data-id="element-164">
            © {new Date().getFullYear()} Construye Progreso™ — Todos los derechos reservados.
          </p>
          <p className="text-[10px] text-gray-400 m-0" data-id="element-165">
            Prohibida la reproducción total o parcial y la redistribución sin autorización expresa.
          </p>
        </div>

      </div>
    </footer>;
}